var _defs, _g, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMapidApps(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 95.14,
    height: 105.13,
    viewBox: "0 0 25.172 27.816",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".cls-1{fill:#50a0f0;}.cls-2{fill:#a9ce71;}.cls-3{fill:#356397;}.cls-4{fill:none;}.cls-10,.cls-4{stroke:#000;}.cls-10,.cls-4,.cls-5,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-5{fill:#fff;stroke:#050505;}.cls-6{fill:#020202;}.cls-6,.cls-7{stroke:#fff;}.cls-7{font-size:125px;fill:#f8f9f7;font-family:MyriadPro-Regular, Myriad Pro;}.cls-8{letter-spacing:0.01em;}.cls-9{letter-spacing:0em;}.cls-10{fill:#fcfcfc;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(.64837 0 0 .64837 4.0049 6.7798e-5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon1",
    className: "cls-1",
    transform: "matrix(.068722 0 0 .068722 .0058926 -.00033318)",
    points: "5.14 247.96 0 246 302 0 354.38 248 219.69 247.96",
    fill: "#50a0f0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon2",
    className: "cls-2",
    transform: "matrix(.068722 0 0 .068722 .0058926 -.00033318)",
    points: "354.38 248 385 393 288.4 356.12 219.69 247.96",
    fill: "#a9ce71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3",
    className: "cls-3",
    transform: "matrix(.068722 0 0 .068722 .0058926 -.00033318)",
    points: "219.69 247.96 288.4 356.12 5.14 247.96",
    fill: "#104585"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "line3",
    className: "cls-4",
    x1: 93.151,
    x2: 93.121,
    y1: 62.79,
    y2: 62.79,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })), /*#__PURE__*/React.createElement("path", {
    id: "text1",
    d: "m5.5545 27.695-2.6919-7.031h1.3761l2.7722 7.031zm-5.5545 0 2.7722-7.031h1.3761l-2.6919 7.031zm1.3057-1.5468v-1.2154h4.4094v1.2154zm6.643 1.5468v-7.031h2.6115q.74327 0 1.3158.30133.57252.29128.89394.82362.32141.5223.32141 1.2154 0 .683-.31137 1.2154-.31137.53234-.85376.84372-.54239.30132-1.2555.30132h-1.3459v2.3303zm1.3761-3.5958h1.3158q.46203 0 .75332-.30133.30132-.31137.30132-.79349t-.33146-.78345q-.32142-.30133-.83367-.30133h-1.2053zm4.7748 3.5958v-7.031h2.6115q.74327 0 1.3158.30133.57252.29128.89394.82362.32141.5223.32141 1.2154 0 .683-.31137 1.2154-.31137.53234-.85376.84372-.54239.30132-1.2555.30132h-1.3459v2.3303zm1.3761-3.5958h1.3158q.46204 0 .75332-.30133.30133-.31137.30133-.79349t-.33146-.78345q-.32141-.30133-.83367-.30133h-1.2053zm7.1352 3.7164q-.53234 0-.99438-.13059-.46203-.13059-.82363-.36159-.36159-.24106-.60265-.53234-.23102-.29128-.30133-.6127l1.3459-.40177q.13059.3415.46203.59261.33146.24106.83367.2511.53234.0099.8638-.23102.3415-.24106.3415-.62274 0-.33146-.2712-.55243-.26115-.23102-.72318-.35155l-.91402-.24106q-.51226-.13059-.90398-.39172-.39172-.27119-.6127-.66292-.22097-.39172-.22097-.91402 0-.99438.65287-1.5468.66292-.56248 1.8682-.56248.67296 0 1.1752.20088.51226.19084.85376.55243.3415.36159.5223.85376l-1.3359.41181q-.12052-.3415-.44194-.58256-.32142-.24106-.81358-.24106-.50221 0-.79349.23102-.28124.23102-.28124.65287 0 .33146.22097.5223.23102.19084.62274.29128l.92407.23102q.90398.22097 1.4062.7935.50221.57252.50221 1.2756 0 .62274-.30133 1.0948-.30132.46203-.87385.72318t-1.3861.26115z",
    strokeWidth: 0,
    style: {
      paintOrder: "stroke markers fill"
    },
    "aria-label": "APPS"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapidApps);
export default __webpack_public_path__ + "static/media/icon_mapid_apps.29e270190a9eab67a1d16a6938ed4c81.svg";
export { ForwardRef as ReactComponent };